module.exports = __webpack_public_path__ + "img/gags_title.5987d372.png";